import { useEffect } from "react";

const SITE = "https://teerthaatan.com";

export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title;
    const upsert = (selector, tag, baseAttrs, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(tag);
        Object.entries(baseAttrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };
    upsert('meta[name="description"]', "meta", { name: "description" }, { content: description });
    upsert('link[rel="canonical"]', "link", { rel: "canonical" }, { href: SITE + path });
    upsert('meta[property="og:title"]', "meta", { property: "og:title" }, { content: title });
    upsert('meta[property="og:description"]', "meta", { property: "og:description" }, { content: description });
    upsert('meta[property="og:url"]', "meta", { property: "og:url" }, { content: SITE + path });
    upsert('meta[name="twitter:title"]', "meta", { name: "twitter:title" }, { content: title });
    upsert('meta[name="twitter:description"]', "meta", { name: "twitter:description" }, { content: description });
  }, [title, description, path]);
  return null;
}
